import onboardingSerivce from '@App/Auth/services/onboardingService'
import { CoreInput } from '@Core/Components/Input'
import CoreOtpInput from '@Core/Components/Input/CoreOtpInput'
import { errorMsg, successMsg } from '@Core/Helpers/Message'
import { hideLoadingPage, showLoadingPage } from '@Core/Helpers/System'
import Yup from '@Core/Helpers/Yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { CheckCircle } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Alert, Button, Typography } from '@mui/material'
import { useCountDown } from 'ahooks'
import Image from 'mui-image'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useCoreAuthActions } from '../CoreAuthProvider'
// import PropTypes from 'prop-types'

const VerifyMobileForm = ({ onVerify = () => {} }) => {
	const [isSend, setIsSend] = useState(false)
	const { logout } = useCoreAuthActions()

	const [targetTime, setTargetTime] = useState(null)

	const [countdown, formattedRes] = useCountDown({
		targetDate: targetTime
	})

	const { minutes, seconds } = formattedRes

	const {
		control,
		handleSubmit,
		formState: { isSubmitting, isDirty },
		setError,
		getValues,
		clearErrors
	} = useForm({
		mode: 'onTouched',
		defaultValues: {
			phone: '',
			otp: ''
		},
		resolver: yupResolver(
			Yup.object({
				phone: Yup.string().required().phone()
			})
		)
	})

	const onSubmitSend = handleSubmit(async data => {
		try {
			setIsSend(false)
			const res = await onboardingSerivce.sendOTP(data)
			setIsSend(true)
			setTargetTime(Date.now() + 5 * 60 * 1000)
		} catch (e) {
			setIsSend(false)
			errorMsg(e)
		}
	})

	const onSubmitOtp = async () => {
		try {
			clearErrors()

			const data = getValues()
			if (!data?.phone) {
				setError('phone', {
					message: 'Đây là trường bắt buộc',
					type: 'custom'
				})
				return false
			}
			if (!data?.otp) {
				setError('otp', {
					message: 'Đây là trường bắt buộc',
					type: 'custom'
				})
				return false
			}
			showLoadingPage()
			const res = await onboardingSerivce.verifyOTP(data)
			successMsg('Xác thực số điện thoại thành công')
			onVerify()
			hideLoadingPage()
		} catch (e) {
			hideLoadingPage()
			setIsSend(false)
			errorMsg(e)
		}
	}

	return (
		<div>
			{/* <div>
				<Image className="h-320" src="/assets/images/auth/email_reset_password.png" />
			</div> */}
			<div className="flex flex-col gap-3 mb-5">
				<Typography variant="M16">
					Xác minh số điện thoại giúp chúng tôi bảo vệ tài khoản của bạn tốt hơn.
				</Typography>
				<div className="flex gap-2">
					<CheckCircle color="success" />
					<Typography>Tăng cường bảo mật, bảo vệ tài khoản khi gặp sự cố.</Typography>
				</div>
				<div className="flex gap-2">
					<CheckCircle color="success" />
					<Typography>Hạn chế các hành vi giả mạo tài khoản, gây ảnh hưởng đến cộng đồng học tập.</Typography>
				</div>
				{/* <div className="flex gap-2">
					<CheckCircle color="success" />
					<Typography>Khám phá các tính năng tuyệt vời của EduQuiz.</Typography>
				</div> */}
				<Alert severity="info">
					Vui lòng nhập đúng số điện thoại đã liên kết với Zalo, EduQuiz sẽ gửi mã xác thực OTP qua tài khoản
					Zalo của bạn.
				</Alert>
			</div>
			<div className="flex flex-col gap-formItem">
				<div>
					<CoreInput required control={control} name="phone" label="Số điện thoại liên kết với Zalo" />
					{!isSend && (
						<LoadingButton loading={isSubmitting} type="button" onClick={onSubmitSend} className="my-1">
							Click để nhận mã OTP qua Zalo
						</LoadingButton>
					)}

					{isSend && (
						<Alert className="my-1">
							Mã xác thực OTP đã được gửi đến Zalo của bạn. Hiệu lực còn lại {minutes}:
							{seconds < 10 ? `0${seconds}` : seconds}
						</Alert>
					)}
				</div>
				<CoreInput
					control={control}
					label="Nhập mã OTP"
					placeholder="Nhập mã OTP của bạn"
					name="otp"
					// numInputs={6}
					required
					className="w-full sm:w-1/2"
				/>
				{/* <CoreOtpInput
					control={control}
					label="Nhập mã OTP"
					// placeholder={t('placeholder.email')}
					name="otp"
					numInputs={6}
					required
				/> */}

				<div className="flex gap-2">
					<Button
						variant="contained"
						className="whitespace-nowrap"
						disableElevation
						color="warning"
						onClick={logout}
					>
						Đăng xuất
					</Button>
					<LoadingButton
						type="button"
						className="w-max sm:w-full"
						variant="main-gradient"
						loading={isSubmitting}
						onClick={onSubmitOtp}
						// loading={isSubmitting}
						// disabled={!isDirty || isSubmitting}
					>
						Xác nhận mã OTP
					</LoadingButton>
				</div>
			</div>
		</div>
	)
}

// VerifyOTP.defaultProps = {}

// VerifyOTP.propTypes = {}

export default React.memo(VerifyMobileForm)
